import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from 'components/ConfirmationModal';
import DataPopover from 'components/DataPopover';
import TextButton from 'components/TextButton';
import './IconButton.css';

class IconButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showFilled: this.props.filled,
      showConfirmation: false
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
  }

  handleClick(ev) {
    ev.stopPropagation();
    if (this.props.confirmation) {
      this.setState({ showConfirmation: true });
    } else if (this.props.onClick) {
      this.props.onClick(ev);
    }
  }

  handleSelection(choice, ev) {
    this.setState({ showConfirmation: false });
    if (choice && this.props.onClick) {
      this.props.onClick(ev);
    }
  }

  handleEnter(ev) {
    this.setState({ showFilled: !this.props.filled });
  }

  handleLeave(ev) {
    this.setState({ showFilled: this.props.filled });
  }

  componentWillReceiveProps(nextProps) {
    const { filled } = nextProps;

    if (filled !== this.props.filled) {
      this.setState({ showFilled: filled });
    }
  }

  render() {
    const {
      icon: IconComp,
      alt,
      title,
      size,
      filled,
      disabled,
      onClick,
      label,
      count,
      confirmation,
      tooltipMessage,
      tooltipClass,
      ...rest
    } = this.props;
    const { showFilled, showConfirmation } = this.state;
    let setTitle = title;
    if (setTitle === true) {
      setTitle = alt;
    }

    let button = (
      <TextButton
        className="icon-button"
        onClick={this.handleClick}
        onMouseEnter={disabled || !onClick ? undefined : this.handleEnter}
        onMouseLeave={disabled || !onClick ? undefined : this.handleLeave}
        disabled={disabled}
      >
        <IconComp
          size={size}
          filled={showFilled}
          disabled={disabled}
          alt={alt}
          title={setTitle}
          {...rest}
        />
        {(label || count > 0) && (
          <span className="icon-label">{label || count}</span>
        )}
      </TextButton>
    );

    if (tooltipMessage) {
      button = (
        <DataPopover
          tooltipMessage={tooltipMessage}
          tooltipClass={tooltipClass}
        >
          {button}
        </DataPopover>
      );
    }

    return (
      <Fragment>
        {button}
        {showConfirmation && (
          <ConfirmationModal
            onSelection={this.handleSelection}
            confirmText="Confirm"
            cancelText="Cancel"
            show={true}
          >
            {confirmation}
          </ConfirmationModal>
        )}
      </Fragment>
    );
  }
}

IconButton.propTypes = {
  type: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  filled: PropTypes.bool,
  label: PropTypes.string,
  count: PropTypes.number,
  confirmation: PropTypes.string,
  tooltipMessage: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  tooltipClass: PropTypes.string
};

export default IconButton;
